<template>
  <q-page-container>
    <q-page class="">
      <section class="section-service-stepper">
        <q-option-group hidden v-model="panel" inline :options="panelList" />
        <q-tab-panels v-model="panel" class="step-panels">
          <q-tab-panel
            class="panel-item"
            v-for="panelItem in formList"
            :key="panelItem.labelTab"
            :name="panelItem.labelTab"
          >
            <component
              ref="tabFormRef"
              :itemOsContract="schemeSolicitation"
              :typeOs="attendanceOption"
              :is="panelItem.component"
              :contract="formScheme"
              :optionsItens="optionsItens"
              @disabledtabButton="(value) => disabledtabButton(value)"
              @getTypeOsClassification="
                (value) => getWriteOffCodeByLowType(value)
              "
              @getTypeOsGenerate="(value) => getTypeOsGenerate(value)"
            />
          </q-tab-panel>
        </q-tab-panels>
        <div>
          <Stepper
            v-if="isShowProgressBar"
            :progressBarValue="progressBar"
            :maxValue="VALUE_MAX_BAR_PROGRESS"
            :finishFn="finishAttendance"
            :nextTabFn="addValueBarProgressAndAlterTab"
            :isLoading="isLoading"
            :isDisabled="isDisabled"
          />
        </div>
      </section>
    </q-page>
  </q-page-container>
</template>

<script>
import AttendanceClock from "@/components/generatedOsForm/AttendanceClock.vue";
import ContractData from "@/components/generatedOsForm/ContractData.vue";
import ContractDataCityOSGeneration from "@/components/generatedOsForm/ContractDataCityOSGeneration.vue";
import SolicitationList from "@/components/generatedOsForm/SolicitationList.vue";
import TechnicianData from "@/components/generatedOsForm/TechnicianData.vue";
import Stepper from "@/components/stepper/formStepper.vue";
import { showNotifyError } from "@/helpers/notifyHelper";
import LowProductionServices from "@/services/LowProductionServices";
import generateUUIDv4 from "@/utils/generetaUUID.js";
import { onMounted, reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import createJsonGenerateOs from "../../utils/ResquestOsForms/createJsonGenerateOs";
import { getTypeLow } from "../../utils/ResquestOsForms/getTypeOSnameById";
import { VISITA_TECNICA_2, MANUTENCAO_INDOOR_GPON } from "@/utils/constants/typeOs/generateOs";
import { computed } from "vue";
import moment from "moment-timezone";
import { MDU_MODERNIZACAO } from "@/utils/constants/typeAttendance";

export default {
  name: "FormGenerateOs",
  components: {
    ContractData,
    ContractDataCityOSGeneration,
    AttendanceClock,
    SolicitationList,
    TechnicianData,
    Stepper,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();

    let isLoading = ref(false);
    let toggleLoading = () => (isLoading.value = !isLoading.value);

    const lowProductionServices = new LowProductionServices();
    const listActionOptionsFilterByIdTypeOs = ["7", "8"];
    let osTypesWithAttendanceClock = [VISITA_TECNICA_2];
    const VALUE_MAX_BAR_PROGRESS = 1;

    const optionsItens = reactive({
      optionsAccredited: [],
      optionsCity: [],
      optionsCodCity: [],
      optionsTypeOS: [],
      optionsWriteOffCode: [],
      optionsActionOs: [],
      equipamentsOS: [],
      generateOptions: [],
    });

    let formScheme = ref({
      accredited: "",
      numberPhone: "",
      contractNumber: "",
      optionsAccredited: "",
      contractGenerateOs: "",
      codeCityGenerateOs: "",   
      codeCity: null,
      city: null,
      contractOs: null,
      dateStartedAttendance: moment().tz("America/Sao_Paulo").format("YYYY-MM-DD HH:mm:ss"),
      dateFinishedAttendance: moment().tz("America/Sao_Paulo").format("YYYY-MM-DD HH:mm:ss"),
      solicitations: [],
    });
    let tabFormRef = ref(null);
    let attendanceOption = ref({});
    let formList = ref([]);
    let panelList = ref([]);
    let panel = ref("tab-1");
    let progressBar = ref(0);
    let isShowProgressBar = ref(true);
    let isDisabled = ref(false);

    let schemeSolicitation = {
      object_id: generateUUIDv4(),
      osNumber: "",
      typeOS: null,
      movimentTerminal: 0,
      writeOffCode: null,
      action: null,
      state: null,
      observation: "",
      equipamentNumberInstall: "",
      IsDecoderComum: false,
      cardNumberInstaled: "",
    };

    const optionsPanel = [
      { label: "tab-1", value: "tab-1" },
      { label: "tab-2", value: "tab-2" },
      { label: "tab-3", value: "tab-3" },
      { label: "tab-4", value: "tab-4" },

    ];

    const components = {
      "tab-1": TechnicianData,
      "tab-2": ContractData,
      "tab-3": SolicitationList,
      "tab-4": AttendanceClock,
    };

    const isVisitaTecnica2 = computed(() => {
      return Number(attendanceOption.value.os_type) === VISITA_TECNICA_2;
    });

    function _handleFormByTypeOs() {
      attendanceOption.value = route.params;
      let mappedOptions = optionsPanel.map((item) => {
        return {
          labelTab: item.label,
          component: components[item.label],
        };
      });
  
      if (MANUTENCAO_INDOOR_GPON == Number(attendanceOption.value.os_type)) { 
        mappedOptions[2].labelTab = "tab-4";
        mappedOptions[2].value = "tab-4";

        mappedOptions[3].labelTab = "tab-5";
        mappedOptions[3].value = "tab-5";
        
        mappedOptions.splice(2, 0, {
          labelTab: "tab-3",
          value: "tab-3",
          component: ContractDataCityOSGeneration,
        });
      }

      if (
        !osTypesWithAttendanceClock.includes(
          Number(attendanceOption.value.os_type)
        )
      ) {
        const filteredOptions = mappedOptions.slice(0, -1);
        formList.value = filteredOptions;
        panelList.value = filteredOptions;
      } else {
        panelList.value = optionsPanel;
        formList.value = mappedOptions;
      }

      progressBar.value = 1 / formList.value.length;
    }

    function disabledtabButton(value) {
      isShowProgressBar.value = value;
    }

    function redirectToServiceHistory() {
      let token = localStorage.getItem("access_token");
      router.replace({
        name: "service-history",
        query: { access_token: token },
      });
    }

    function changePanelTabValue() {
      const VALUE_ADD_PROGRESS = 1 / formList.value.length;

      let number = _getNextProgressPageNumber();
      panel.value = `tab-${number}`;

      if (progressBar.value != VALUE_MAX_BAR_PROGRESS) {
        progressBar.value += VALUE_ADD_PROGRESS;
      }
    }

    async function addValueBarProgressAndAlterTab() {
      if (MANUTENCAO_INDOOR_GPON == Number(attendanceOption.value.os_type)) {
        if (await tabFormRef.value[0].validateForm()) {
          changePanelTabValue();
        }
        return;
      }

      if (components[panel.value].name.toString() == 'SolicitationList') {
        if (formScheme.value.solicitations[0].isFilled == true) {
          changePanelTabValue();
          return;
        } else {
          showNotifyError("Você tem que preencher uma solicitacão");
          return;
        }
      }

      if (await tabFormRef.value[0].validateForm()) {
        changePanelTabValue();
      }
    }

    async function createGenerateOs() {
      if (await tabFormRef.value[0].validateForm()) {
        
        let jsonGenerateOs = await createJsonGenerateOs(formScheme.value);

        jsonGenerateOs.osRequests[0].IdServiceOption = parseInt(
          route.params.os_type
        );

        if(Number(route.params.os_type) !== MDU_MODERNIZACAO){
          delete jsonGenerateOs.osRequests[0].dateTertiary;
        }

        if (Number(route.params.os_type) !== VISITA_TECNICA_2) {
          delete jsonGenerateOs.osRequests[0].typeOsForAttendance;
        }

        if (Number(route.params.os_type) === MANUTENCAO_INDOOR_GPON) {
          jsonGenerateOs.osRequests[0].contractGenerateOs = formScheme.value.contractGenerateOs;
          jsonGenerateOs.osRequests[0].codeCityGenerateOs = formScheme.value.codeCityGenerateOs;
        }

        toggleLoading();

        await lowProductionServices
          .saveGenerateOs(jsonGenerateOs)
          .then((response) => {
            redirectToServiceHistory();
            toggleLoading();
          })
          .catch((error) => {
            toggleLoading();
            if (error.response && error.response.data) {
              isDisabled.value = true;
              showNotifyError(error.response.data);
            } else {
              showNotifyError(
                "Erro ao gerar OS. Por favor refaça o formulário"
              );
            }
          });
      }
    }

    async function finishAttendance() {
      const isLastStep = panel.value == `tab-${formList.value.length}`;
      
      if (isLastStep) {
        if (!formScheme.value.solicitations[0].isFilled == true) {
          showNotifyError("Você tem que preencher uma solicitacão");
          return;
        }
        createGenerateOs();
      }
    }

    function _getNextProgressPageNumber() {
      let panelSplited = panel.value.split("-");

      return parseInt(panelSplited.slice(-1).pop(), 10) + 1;
    }

    async function _getCitiesActives() {
      await lowProductionServices.getCitiesActives().then((response) => {
        optionsItens.optionsCity = response;
        optionsItens.optionsCodCity = response;
      });
    }

    function _getAccreditedsActives() {
      lowProductionServices.getAccreditedsActives().then((response) => {
        optionsItens.optionsAccredited = response;
      });
    }

    function _getTypeOsByServiceOption() {
      lowProductionServices
        .getTypeOsByServiceOption(attendanceOption.value.os_type)
        .then((response) => {
          optionsItens.optionsTypeOS = response;
        });
    }

    function _getAllActions() {
      lowProductionServices.getAllActions().then((response) => {
        listActionOptionsFilterByIdTypeOs.includes(
          attendanceOption.value.os_type
        )
          ? (optionsItens.optionsActionOs = response.filter(
              (item) => item.id_acao != 3
            ))
          : (optionsItens.optionsActionOs = response);
      });
    }

    function _getAllStateEquipaments() {
      lowProductionServices.getAllStateEquipaments().then((response) => {
        optionsItens.equipamentsOS = response;
      });
    }

    function getWriteOffCodeByLowType(actionId = null) {
      let typeOs = getTypeLow(9, actionId);
      if (isVisitaTecnica2.value) {
        return;
      } else {
        lowProductionServices
          .getWriteOffCodeByLowType(typeOs, actionId)
          .then((response) => {
            optionsItens.optionsWriteOffCode = response;
          });
      }
    }

    function getAllWriteOffActives() {
      lowProductionServices.getWriteOffCodeActives().then((response) => {
        optionsItens.optionsWriteOffCode = response.filter((item) => {
          return item.value === 530;
        });
      });
    }

    function getTypeOsGenerate(attendanceId) {
      lowProductionServices
        .getTypeOsById(attendanceOption.value.os_type, attendanceId)
        .then((response) => {
          optionsItens.generateOptions = response;
        });
    }

    function _getDefaultTechnicianData() {
      formScheme.value.accredited = store.state.accredited;
      formScheme.value.numberPhone = store.state.numberPhone;

      if (store.state.addressCity != "") {
        lowProductionServices
          .getCodeCityByName(store.state.addressCity)
          .then((response) => {
            formScheme.codeCity = {
              text: response.cidade,
              value: response.codcidadenetsms,
            };
            formScheme.city = {
              text: response.cidade,
              value: response.codcidadenetsms,
            };
          });
      }
    }

    function _getWriteOffCodes() {
      if (isVisitaTecnica2.value) {
        getAllWriteOffActives();
      } else {
        getWriteOffCodeByLowType();
      }
    }

    onMounted(() => {
      _handleFormByTypeOs();
      _getDefaultTechnicianData();
      _getAccreditedsActives();
      _getCitiesActives();
      _getTypeOsByServiceOption();
      _getAllActions();
      _getAllStateEquipaments();
      _getWriteOffCodes();
    });

    return {
      //-----COMPONENTS
      ContractData,
      AttendanceClock,
      //-----VARIENTES
      formList,
      panelList,
      panel,
      formScheme,
      optionsItens,
      progressBar,
      isShowProgressBar,
      schemeSolicitation,
      tabFormRef,
      attendanceOption,
      //-----FUNCTIONS
      disabledtabButton,
      addValueBarProgressAndAlterTab,
      finishAttendance,
      getWriteOffCodeByLowType,
      isLoading,
      changePanelTabValue,
      isDisabled,
      VALUE_MAX_BAR_PROGRESS,
      getTypeOsGenerate,
      VISITA_TECNICA_2,
      getAllWriteOffActives,
    };
  },
};
</script>

<style lang="scss">
section-service-stepper {
  display: flex;
  height: 100vh;
  width: 100vw;
}

.step-panels {
  background: transparent !important;
  overflow: hidden !important;
  display: flex;

  .panel-item {
    width: 100%;
    // padding-right: 15px;
  }
}

.title-page {
  font-weight: bold;
  font-size: 18px;
  line-height: 19px;
  text-transform: uppercase;
  color: #e2262d;
}

label {
  font-weight: bold;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.4);
}
</style>
